import { render } from "./WelcomeSlider.vue?vue&type=template&id=907eae20"
import script from "./WelcomeSlider.vue?vue&type=script&lang=js"
export * from "./WelcomeSlider.vue?vue&type=script&lang=js"

import "./WelcomeSlider.vue?vue&type=style&index=0&id=907eae20&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__